/**
 * @generated SignedSource<<df363e077aad157ee15d1f1d2c735827>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime'
import { FragmentRefs } from 'relay-runtime'
export type Ranking_rankingCemeteries$data = {
  readonly items: ReadonlyArray<{
    readonly cemeteryId: number
    readonly ' $fragmentSpreads': FragmentRefs<'useCemeteryTinyItem_cemetery'>
  }>
  readonly ' $fragmentType': 'Ranking_rankingCemeteries'
}
export type Ranking_rankingCemeteries$key = {
  readonly ' $data'?: Ranking_rankingCemeteries$data
  readonly ' $fragmentSpreads': FragmentRefs<'Ranking_rankingCemeteries'>
}

const node: ReaderFragment = {
  argumentDefinitions: [],
  kind: 'Fragment',
  metadata: null,
  name: 'Ranking_rankingCemeteries',
  selections: [
    {
      alias: null,
      args: null,
      concreteType: 'Cemetery',
      kind: 'LinkedField',
      name: 'items',
      plural: true,
      selections: [
        {
          alias: 'cemeteryId',
          args: null,
          kind: 'ScalarField',
          name: 'id',
          storageKey: null
        },
        {
          args: null,
          kind: 'FragmentSpread',
          name: 'useCemeteryTinyItem_cemetery'
        }
      ],
      storageKey: null
    }
  ],
  type: 'CemeteryResult',
  abstractKey: null
}

;(node as any).hash = '2d6e2437aec18592593ec69593c5e017'

export default node
